<template>
  <div class="relative">
    <div class="gap-6 grid grid-cols-12">
      <ArticleCard
        v-for="(article, index) in articles"
        class="rounded-12 col-span-12 sm:col-span-6 lg:col-span-3"
        :class="{ 'lg:col-span-4': isArticleLarge(index) }"
        :key="`content-${index}`"
        :article="article"
        :is-large="isArticleLarge(index)"
      />
      <div
        v-for="n in 3"
        :key="`ghost-${n}`"
        class="rounded-12 col-span-12 sm:col-span-6 lg:col-span-3 hidden sm:block bg-gray-100"
        :class="{ 'lg:col-span-4': articles.length <= 2 }"
      />
    </div>
    <a
      v-if="optionalCta"
      class="pt-4 font-semibold underline text-gray-500 block text-center"
      :href="optionalCta?.link ?? undefined"
    >
      {{ optionalCta?.label }}
    </a>
  </div>
</template>

<script lang="ts" setup>
import ArticleCard from './article-card.vue'
import type { GQLRelatedContentSlice } from './generated/related-content'

const props = defineProps<{
  optionalCta: GQLRelatedContentSlice['optionalCta']
  articles: GQLRelatedContentSlice['articleLinks']
}>()

function isArticleLarge(index: number) {
  return index < 3 && props.articles.length !== 4
}
</script>
